<template>
  <PapeleriaElistmentForm :typeEndPoint="'papeleriaElistmentShow'" :dataParams="this.$route.params" />
</template>
<script>
import PapeleriaElistmentForm from '@/components/modules/papeleria/enlistment/form'
export default {
  name: 'PapeleriaElistmentEdit',
  components: {
    PapeleriaElistmentForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/enlistment/edit.vue